import React from 'react'
import { Accordion, AccordionItem } from '@react/react-spectrum/Accordion'
import Alert from '@react/react-spectrum/Alert'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    })
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className='error-wrapper'>
          <Alert variant='error' header='Error'>
            <p>Something went wrong...</p>
            {this.state.error && (
              <Accordion>
                <AccordionItem header='Details'>
                  <p>{this.state.error.toString()}</p>
                  <ul>
                    {this.state.errorInfo.componentStack &&
                      this.state.errorInfo.componentStack
                        .split('\n')
                        .map((item, idx) => item && item.trim() && <li key={idx}>{item.trim()}</li>)}
                  </ul>
                </AccordionItem>
              </Accordion>
            )}
          </Alert>
        </div>
      )
    } else {
      return this.props.children
    }
  }
}

export default ErrorBoundary
